import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedNumber, IntlProvider } from 'react-intl';
import { getCurrency } from '../../../utils';
import Image from '../../../components/ContentfulImage';
import Placeholder from '../../../components/Placeholder';

import {
  Wrapper,
  ContentContainer,
  TitleText,
  ItemWrap,
  ItemList,
  ImageCover,
  SectionText,
  SectionTextTitle,
  SectionTextTitleName,
  SectionTextVariantTitle,
  SectionTextVariantDesc,
  Package,
  LabelIcon,
  HowToUseContainer,
  HowToUseButton,
} from './SublimicHomeCareItemDetailPage.style';

const SublimicHomeCareItemDetailPage = props => {
  const { locale, copy, match, siteOptions } = props;
  const ownCopy = siteOptions.siteCopy ? siteOptions.siteCopy.homeCareItemDetail : {};
  const { slug } = match.params;
  const itemList = copy
    ? [...(copy.hairCareItems || []), ...(copy.scalpCareItems || []), ...(copy.hairAndScalpCareItems || [])]
    : [];
  const item = itemList.find(item => item.slug === slug) || [];

  const data = (item && item.categories && item.categories) || [];
  return (
    <Wrapper>
      <ContentContainer>
        <TitleText>{item.name || <Placeholder w={['280px', '428px']} h={['30px', '38px']} />}</TitleText>
        <ItemWrap>
          {data.length ? (
            data.map(categories =>
              categories.subCategories.map(({ name, image, slug, products, steps, description }) => (
                <ItemList key={name}>
                  <LabelIcon>{categories.name}</LabelIcon>
                  <ImageCover>
                    {(!!image && (
                      <Image
                        src={image}
                        options={{
                          w: ['118px', '240px'],
                        }}
                      />
                    )) || <Placeholder w="240px" h="180px" />}
                  </ImageCover>
                  <SectionText>
                    <SectionTextTitleName>
                      {item.name}
                      {description}
                    </SectionTextTitleName>
                    <SectionTextTitle>{name}</SectionTextTitle>
                    {products &&
                      products.map(({ subTitle, description, entryId }) => (
                        <React.Fragment key={entryId}>
                          {subTitle && <SectionTextVariantTitle>{subTitle}</SectionTextVariantTitle>}
                          <SectionTextVariantDesc>{description}</SectionTextVariantDesc>
                        </React.Fragment>
                      ))}
                    {products &&
                      products[0] &&
                      products[0].product &&
                      products[0].product.variants &&
                      products[0].product.variants.map(({ entryId, volume, unit, price, salonExclusive }) => (
                        <Package key={entryId}>
                          {Boolean(!salonExclusive) && (
                            <React.Fragment>
                              {products.length > 1 && ownCopy.each}
                              {`${volume}${unit} `}
                              {Boolean(price && locale) && (
                                <IntlProvider locale={locale.split('_')[0]}>
                                  <FormattedNumber value={price} style="currency" currency={getCurrency(locale)} />
                                </IntlProvider>
                              )}
                            </React.Fragment>
                          )}
                        </Package>
                      ))}
                    {steps &&
                      steps.steps &&
                      steps.steps.length > 0 && (
                        <HowToUseContainer>
                          <HowToUseButton
                            to={`/${locale}/salon-consultation/sublimic/homecare/${slug}/step`}
                            href={`/${locale}/salon-consultation/sublimic/homecare/${slug}/step`}
                          >
                            {ownCopy.viewHomeCareStep || <Placeholder w="132px" h="40px" />}
                          </HowToUseButton>
                        </HowToUseContainer>
                      )}
                  </SectionText>
                </ItemList>
              ))
            )
          ) : (
            <React.Fragment>
              <Placeholder w={['100%', '728px']} h={['270px', '240px']} mb="10px" />
              <Placeholder w={['100%', '728px']} h={['270px', '240px']} mb="10px" />
              <Placeholder w={['100%', '728px']} h={['270px', '240px']} />
            </React.Fragment>
          )}
        </ItemWrap>
      </ContentContainer>
    </Wrapper>
  );
};

SublimicHomeCareItemDetailPage.defaultProps = {
  copy: {},
  siteOptions: {},
};
SublimicHomeCareItemDetailPage.propTypes = {
  copy: PropTypes.shape({}),
  siteOptions: PropTypes.shape({}),
  locale: PropTypes.string.isRequired,
  match: PropTypes.shape({}).isRequired,
};
const mapState = state => ({
  copy: state.homeCareItemList,
  siteOptions: state.salonConsultaionSiteOptions,
  locale: state.locale,
});

export default connect(mapState)(SublimicHomeCareItemDetailPage);



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicHomeCareItemDetailPage/SublimicHomeCareItemDetailPage.js